import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledEmailAlertButton = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 6px 8px;
    width: 60px;
    align-items: center;

    &:hover {
        cursor: pointer;
        border-radius: 6px;
        background: rgba(182, 190, 198, 0.2);
    }
`;

export const StyledActiveAlertIcon = styled(SWReactIcons)`
    path {
        fill: ${colorsPalettes.blue[400]};
    }
`;

export const StyledInactiveAlertIcon = styled(SWReactIcons)`
    path {
        fill: ${colorsPalettes.carbon[200]};
    }
`;

export const StyledCaption = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[250])}
    line-height:14px;
    text-align: center;
`;
